import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import api from '../components/api';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    LabelList,
    
} from 'recharts';

const StateByIndicateurPage = () => {
    const [selectedIndicator, setSelectedIndicator] = useState('');
    const [statsData, setStatsData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const indicators = [
       
        { 
            id: 'authorization', 
            label: 'Disponibilité d\'une autorisation',
            chartTitle: 'Proportion des dépôts de médicaments possedant une autorisation selon la région'
        },
        { 
            id: 'retail_sale_norm', 
            label: 'Respect de la norme de la vente en détails',
            chartTitle: 'Type de vente des dépôts de médicaments selon la région',
            articleText: 'Article premier: Le présent arrêté détermine les conditions d\'ouverture et d\'exploitation d\'un dépôt de médicaments. Le dépôt de médicaments est un établissement affecté à la vente au détail des produits de santé dans la limite autorisée par la réglementation en vigueur.'
        },
        { 
            id: 'surface_norm', 
            label: 'Respect des normes en matière de superficie',
            chartTitle: 'Superficie des dépôts de médicaments selon la région',
            articleText: 'Article 2 : Les locaux devant abriter un dépôt de médicaments doivent avoir une superficie minimum de vingt (20) mètres carrés et disposer d\'au moins d\'une aire de stockage suffisante et d\'une aire de vente.'
        },
        { 
            id: 'storage_area', 
            label: 'De l\'aire de stockage',
            chartTitle: 'Existence d\'une aire de stockage selon la région'
        },
        { 
            id: 'sales_area', 
            label: 'De l\'aire de vente',
            chartTitle: 'Existence d\'une aire de vente selon la région',
            articleText: 'Article 2 : Les locaux devant abriter un dépôt de médicaments doivent avoir une superficie minimum de vingt (20) mètres carrés et disposer d\'au moins d\'une aire de stockage suffisante et d\'une aire de vente.'
        },
        { 
            id: 'reception_area', 
            label: 'De l\'aire de réception',
            chartTitle: 'Existence d\'une aire de réception selon la région'
        },
        { 
            id: 'identification_plate', 
            label: 'Respect des normes en matière de plaque d\'identification',
            chartTitle: 'Proportion des dépôts de médicaments ayant des plaques respectant les normes selon la région',
            articleText: 'Article 3: Tout dépôt de médicaments doit se signaler par une plaque de couleur verte portant les écrits suivants en couleur blanche : - la dénomination avec la mention obligatoire suivante « dépôt de médicaments » ; - la croix grecque de couleur verte, le caducée pharmaceutique étant interdit car réservés exclusivement aux officines de pharmacie ; - le nom et numéro de téléphone du responsable du dépôt.'
        },
        {
            id: 'manager_nationality',
            label: 'Respect des normes en matière de nationalité des gérants',
            chartTitle: 'Proportion des gérants de nationalité nigérienne selon la région',
            articleText: 'Article 4 : Nul ne peut exercer la fonction de gérant d\'un dépôt de médicaments s\'il ne présente toutes garanties de bonne moralité. En outre, il doit remplir les conditions suivantes : - être de nationalité nigérienne et résident dans la localité considérée ; - être titulaire d\'un diplôme de technicien supérieur en santé ; - être libre de tout engagement avec l\'État ou une personne morale de droit privé.'
        },
        { 
            id: 'type_diplome',
            label: 'Type de diplôme des gérants',
            chartTitle: 'Répartition des types de diplômes des gérants selon la région',
            articleText: 'Article 4 : Nul ne peut exercer la fonction de gérant d\'un dépôt de médicaments s\'il ne présente toutes garanties de bonne moralité. En outre, il doit remplir les conditions suivantes : - être de nationalité nigérienne et résident dans la localité considérée ; - être titulaire d\'un diplôme de technicien supérieur en santé ; - être libre de tout engagement avec l\'État ou une personne morale de droit privé.'
        },
        { 
            id: 'manager_engagement', 
            label: 'Proportion des gérants libre de tout engagement',
            chartTitle: 'Proportion des gérants libre de tout engagement selon la région',
            articleText: 'Article 4 : Nul ne peut exercer la fonction de gérant d\'un dépôt de médicaments s\'il ne présente toutes garanties de bonne moralité. En outre, il doit remplir les conditions suivantes : - être de nationalité nigérienne et résident dans la localité considérée ; - être titulaire d\'un diplôme de technicien supérieur en santé ; - être libre de tout engagement avec l\'État ou une personne morale de droit privé.'
        },
        { 
            id: 'manager_function', 
            label: 'Type de formation des gérants',
            chartTitle: 'Type de formation des gérants selon la région',
            articleText: 'Article 4 : Nul ne peut exercer la fonction de gérant d\'un dépôt de médicaments s\'il ne présente toutes garanties de bonne moralité. En outre, il doit remplir les conditions suivantes : - être de nationalité nigérienne et résident dans la localité considérée ; - être titulaire d\'un diplôme de technicien supérieur en santé ; - être libre de tout engagement avec l\'État ou une personne morale de droit privé.'
        },
        { 
            id: 'assistant_contract', 
            label: 'Assistant avec contrat formel',
            chartTitle: 'Proportion des dépôts ayant un assistant avec contrat formel selon la région',
            articleText: 'Article 5 : Ne peuvent être employés, comme assistant au gérant dans les dépôts de médicaments que les titulaires d\'au moins d\'un Brevet d\'Etudes du Premier Cycle (BEPC) ou d\'un diplôme équivalent.'
        },
        { 
            id: 'assistant_education', 
            label: 'Niveau BEPC minimum des assistants',
            chartTitle: 'Proportion des assistants ayant au minimum le BEPC selon la région',
            articleText: 'Article 5 : Ne peuvent être employés, comme assistant au gérant dans les dépôts de médicaments que les titulaires d\'au moins d\'un Brevet d\'Etudes du Premier Cycle (BEPC) ou d\'un diplôme équivalent.'
        },
        { 
            id: 'assistant_norm',
            label: 'Respect des normes sur en matière d\'employabilité des assistants au gérant',
            chartTitle: 'Proportion des dépôts employant des assistants qualifiés selon la région',
            notImplemented: true
        },
        { 
            id: 'supply_source', 
            label: 'Respect des normes en matière de source d\'approvisionnement',
            chartTitle: 'Source d\'approvisionnement des dépôts de médicaments selon la région',
            articleText: 'Article 6 : Les dépôts de médicaments ne peuvent s\'approvisionner en produits de santé qu\'auprès des officines de pharmacie. L\'autorisation d\'ouverture d\'un dépôt de médicaments est incessible et non transmissible. Le gérant du dépôt doit personnellement exercer sa fonction sous la supervision du pharmacien titulaire de l\'officine de pharmacie autorisée à l\'approvisionner.'
        },
        { 
            id: 'authorization_per_manager',
            label: 'Respect des normes relatives au nombre d\'autorisation par gérant',
            chartTitle: 'Proportion des gérants respectant les normes d\'autorisation selon la région',
            notImplemented: true
        },
        { 
            id: 'authorized_activities', 
            label: 'Respect des normes en termes d\'activités autorisées',
            chartTitle: 'Proportion des dépôts respectant les normes d\'activités autorisées selon la région',
            articleText: 'Article 10 : Il est interdit aux gérants des dépôts de médicaments et à leurs employés de pratiquer au sein des dépôts, des activités médicales, paramédicales et celles liées à la préparation ou au reconditionnement des produits de santé.'
        },
        { 
            id: 'price_structure', 
            label: 'Respect des normes en termes de la structure des prix',
            chartTitle: 'Proportion des dépôts respectant la structure des prix selon la région',
            articleText: 'Article 11 : Le gérant d\'un dépôt de médicaments est tenu au respect de la structure des prix de vente des produits de santé établie par arrêté conjoint du Ministre chargé de la Santé Publique et du Ministre chargé du Commerce.',
            notImplemented: true
        },
        { 
            id: 'storage_practice',
            label: 'Respect des normes en termes de bonnes pratiques de stockage et de distribution',
            chartTitle: 'Proportion des dépôts respectant les bonnes pratiques selon la région',
            notImplemented: true
        },
        { 
            id: 'private_pharmacy', 
            label: 'Respect des normes en termes de l\'inexistence d\'une officine privée',
            chartTitle: 'Proportion des dépôts de médicaments se trouvant dans une localité où existe une officine selon la région',
            articleText: 'Article 13 : L\'ouverture et l\'exploitation d\'un dépôt de médicaments ne sont autorisées que dans les localités dépourvues d\'officine de pharmacie ouverte au public.'
        },
        { 
            id: 'health_facility', 
            label: 'Respect des normes en termes d\'existence d\'une formation sanitaire',
            chartTitle: 'Proportion des dépôts de médicament ouvert dans une localité dépourvue d\'une formation sanitaire',
            articleText: 'Article 15 : Un dépôt de médicaments ne peut être ouvert que dans une localité pourvue d\'une formation sanitaire.'
        },
        { 
            id: 'demographic_norm', 
            label: 'Respect des normes démographiques',
            chartTitle: 'Proportion des dépôts respectant les normes démographiques selon la région',
            articleText: 'Article 15 : Un dépôt de médicaments ne peut être ouvert que dans une localité pourvue d\'une formation sanitaire. Une localité pourvue de formation sanitaire ne peut recevoir plus d\'un (1) dépôt que quand sa population est supérieure à cinq mille (5 000) habitants sans toutefois, excéder trois (3) dépôts.'
        },
        { 
            id: 'geographic_norm', 
            label: 'Respect des normes géographiques',
            chartTitle: 'Proportion des dépôts respectant les normes géographiques selon la région',
            articleText: 'Article 20 : L\'autorisation d\'ouverture et d\'exploitation ainsi délivrée est valable uniquement pour la localité choisie et pour un seul dépôt.'
        }
    ];

    // Couleurs plus distinctes et contrastées
    const COLORS = {
        primary: '#2563eb',    // Bleu
        secondary: '#16a34a',  // Vert
        tertiary: '#dc2626',   // Rouge
        quaternary: '#f59e0b'  // Orange
    };

    useEffect(() => {
        const fetchStats = async () => {
            if (!selectedIndicator) return;
            
            setLoading(true);
            setError(null);
            try {
                const response = await api.get(`collect/stats/${selectedIndicator}`);
                
                // Trier les données par ordre alphabétique des régions, mais garder "Ensemble" à la fin
                const sortedData = [...response.data].sort((a, b) => {
                    if (a.name === "Ensemble") return 1;
                    if (b.name === "Ensemble") return -1;
                    return a.name.localeCompare(b.name);
                });
                
                setStatsData(sortedData);
            } catch (err) {
                setError('Erreur lors du chargement des statistiques');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchStats();
    }, [selectedIndicator]);

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            // Calculer la somme des valeurs pour ce groupe
            const sum = payload.reduce((acc, entry) => acc + (entry.value || 0), 0);
            
            return (
                <div className="bg-white p-4 border rounded shadow">
                    <p className="font-bold">{label}</p>
                    {payload.map((entry, index) => (
                        <p key={index} style={{ color: entry.color }}>
                            {entry.name}: {(entry.value || 0).toFixed(1)}%
                        </p>
                    ))}
                    <div className="border-t mt-2 pt-2">
                        <p className="font-bold">Total: {Math.min(sum, 100).toFixed(1)}%</p>
                    </div>
                </div>
            );
        }
        return null;
    };

    const renderChart = () => {
        if (!statsData) return null;

        const simpleBarChartIndicators = [
            'authorized_activities', 'price_structure', 'assistant_contract', 'assistant_education'
        ];

        if (simpleBarChartIndicators.includes(selectedIndicator)) {
            const transformedData = statsData.map(item => ({
                name: item.name,
                Oui: 0,
                Non: 100
            }));

            return (
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={transformedData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis 
                            domain={[0, 100]} 
                            tickFormatter={(value) => Math.round(value)} 
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend verticalAlign="top" align="right" />
                        <Bar dataKey="Oui" stackId="a" fill={COLORS.primary}>
                            <LabelList
                                dataKey="Oui"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                        <Bar dataKey="Non" stackId="a" fill={COLORS.tertiary}>
                            <LabelList
                                dataKey="Non"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        }
        
        // Special treatment for sales_area (100% Oui)
        if (selectedIndicator === 'sales_area') {
            const transformedData = statsData.map(item => ({
                name: item.name,
                Oui: 100,
                Non: 0
            }));

            return (
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={transformedData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis 
                            domain={[0, 100]} 
                            tickFormatter={(value) => Math.round(value)} 
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend verticalAlign="top" align="right" />
                        <Bar dataKey="Oui" stackId="a" fill={COLORS.primary}>
                            <LabelList
                                dataKey="Oui"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                        <Bar dataKey="Non" stackId="a" fill={COLORS.tertiary}>
                            <LabelList
                                dataKey="Non"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        }

        // Special treatment for reception_area
        if (selectedIndicator === 'reception_area') {
            const transformedData = statsData.map(item => ({
                name: item.name,
                Oui: item.value,
                Non: 100 - item.value
            }));

            return (
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={transformedData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis 
                            domain={[0, 100]} 
                            tickFormatter={(value) => Math.round(value)} 
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend verticalAlign="top" align="right" />
                        <Bar dataKey="Oui" stackId="a" fill={COLORS.primary}>
                            <LabelList
                                dataKey="Oui"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                        <Bar dataKey="Non" stackId="a" fill={COLORS.tertiary}>
                            <LabelList
                                dataKey="Non"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        }

        // Special treatment for private_pharmacy
        if (selectedIndicator === 'private_pharmacy') {
            const transformedData = statsData.map(item => ({
                name: item.name,
                Oui: item.value,
                Non: 100 - item.value
            }));

            return (
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={transformedData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis 
                            domain={[0, 100]} 
                            tickFormatter={(value) => Math.round(value)} 
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend verticalAlign="top" align="right" />
                        <Bar dataKey="Oui" stackId="a" fill={COLORS.primary}>
                            <LabelList
                                dataKey="Oui"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                        <Bar dataKey="Non" stackId="a" fill={COLORS.tertiary}>
                            <LabelList
                                dataKey="Non"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        }

        // Special treatment for identification_plate
        if (selectedIndicator === 'identification_plate') {
            const transformedData = statsData.map(item => ({
                name: item.name,
                Oui: item.value,
                Non: 100 - item.value
            }));

            return (
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={transformedData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis 
                            domain={[0, 100]} 
                            tickFormatter={(value) => Math.round(value)} 
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend verticalAlign="top" align="right" />
                        <Bar dataKey="Oui" stackId="a" fill={COLORS.primary}>
                            <LabelList
                                dataKey="Oui"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                        <Bar dataKey="Non" stackId="a" fill={COLORS.tertiary}>
                            <LabelList
                                dataKey="Non"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        }

        // Special treatment for authorization
        if (selectedIndicator === 'authorization') {
            const transformedData = statsData.map(item => ({
                name: item.name,
                Oui: item.value,
                Non: 100 - item.value
            }));

            return (
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={transformedData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis 
                            domain={[0, 100]} 
                            tickFormatter={(value) => Math.round(value)} 
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend verticalAlign="top" align="right" />
                        <Bar dataKey="Oui" stackId="a" fill={COLORS.primary}>
                            <LabelList
                                dataKey="Oui"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                        <Bar dataKey="Non" stackId="a" fill={COLORS.tertiary}>
                            <LabelList
                                dataKey="Non"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        }

        // Special treatment for manager_engagement
        if (selectedIndicator === 'manager_engagement') {
            const transformedData = statsData.map(item => ({
                name: item.name,
                'Libres': item.value,
                'Non libres': 100 - item.value
            }));

            return (
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={transformedData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis 
                            domain={[0, 100]} 
                            tickFormatter={(value) => Math.round(value)} 
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend verticalAlign="top" align="right" />
                        <Bar dataKey="Libres" stackId="a" fill={COLORS.primary}>
                            <LabelList
                                dataKey="Libres"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                        <Bar dataKey="Non libres" stackId="a" fill={COLORS.tertiary}>
                            <LabelList
                                dataKey="Non libres"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        }

        // Special treatment for storage_area
        if (selectedIndicator === 'storage_area') {
            const transformedData = statsData.map(item => ({
                name: item.name,
                Oui: item.value,
                Non: 100 - item.value
            }));

            return (
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={transformedData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis 
                            domain={[0, 100]} 
                            tickFormatter={(value) => Math.round(value)} 
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend verticalAlign="top" align="right" />
                        <Bar dataKey="Oui" stackId="a" fill={COLORS.primary}>
                            <LabelList
                                dataKey="Oui"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                        <Bar dataKey="Non" stackId="a" fill={COLORS.tertiary}>
                            <LabelList
                                dataKey="Non"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        }

        // Special treatment for health_facility
        if (selectedIndicator === 'health_facility') {
            const transformedData = statsData.map(item => ({
                name: item.name,
                Oui: item.value,
                Non: 100 - item.value
            }));

            return (
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={transformedData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis 
                            domain={[0, 100]} 
                            tickFormatter={(value) => Math.round(value)} 
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend verticalAlign="top" align="right" />
                        <Bar dataKey="Oui" stackId="a" fill={COLORS.primary}>
                            <LabelList
                                dataKey="Oui"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                        <Bar dataKey="Non" stackId="a" fill={COLORS.tertiary}>
                            <LabelList
                                dataKey="Non"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        }

        // Traitement pour les indicateurs géographiques et démographiques
        if (selectedIndicator === 'demographic_norm') {
            const primaryDataKey = 'Norme respectée';
            const secondaryDataKey = 'Norme non-respectée';
            
            return (
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={statsData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis 
                            domain={[0, 100]} 
                            tickFormatter={(value) => Math.round(value)} 
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend 
                            verticalAlign="top" 
                            align="right"
                        />
                        <Bar dataKey={primaryDataKey} stackId="a" fill={COLORS.primary}>
                            <LabelList
                                dataKey={primaryDataKey}
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                        <Bar dataKey={secondaryDataKey} stackId="a" fill={COLORS.tertiary}>
                            <LabelList
                                dataKey={secondaryDataKey}
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        } else if (selectedIndicator === 'geographic_norm') {
            const primaryDataKey = 'Localisation respecté';
            const secondaryDataKey = 'Localisation non-respecté';
            
            return (
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={statsData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis 
                            domain={[0, 100]} 
                            tickFormatter={(value) => Math.round(value)} 
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend 
                            verticalAlign="top" 
                            align="right"
                        />
                        <Bar dataKey={primaryDataKey} stackId="a" fill={COLORS.primary}>
                            <LabelList
                                dataKey={primaryDataKey}
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                        <Bar dataKey={secondaryDataKey} stackId="a" fill={COLORS.tertiary}>
                            <LabelList
                                dataKey={secondaryDataKey}
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        } else if (selectedIndicator === 'manager_nationality') {
            // Traitement spécial pour la nationalité des gérants
            const transformedData = statsData.map(item => ({
                name: item.name,
                'Nigérienne': item.value,
                'Non nigérienne': 100 - item.value
            }));
            
            return (
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={transformedData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis 
                            domain={[0, 100]} 
                            tickFormatter={(value) => Math.round(value)} 
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend 
                            verticalAlign="top" 
                            align="right"
                        />
                        <Bar dataKey="Nigérienne" stackId="a" fill={COLORS.primary}>
                            <LabelList
                                dataKey="Nigérienne"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                        <Bar dataKey="Non nigérienne" stackId="a" fill={COLORS.tertiary}>
                            <LabelList
                                dataKey="Non nigérienne"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        } else if (selectedIndicator === 'type_diplome') {
            // Traitement spécial pour le type de diplôme des gérants
            return (
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={statsData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis 
                            domain={[0, 100]} 
                            tickFormatter={(value) => Math.round(value)} 
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend 
                            verticalAlign="top" 
                            align="right"
                        />
                        <Bar dataKey="Santé" stackId="a" fill={COLORS.primary}>
                            <LabelList
                                dataKey="Santé"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                        <Bar dataKey="Autres" stackId="a" fill={COLORS.quaternary}>
                            <LabelList
                                dataKey="Autres"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        } else if (selectedIndicator === 'surface_norm') {
            // Traitement spécial pour la superficie des dépôts
            return (
                <ResponsiveContainer width="100%" height={500}>
                    <BarChart
                        data={statsData}
                        layout="vertical"
                        margin={{ top: 20, right: 30, left: 100, bottom: 5 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis type="number" domain={[0, 100]} tickFormatter={(value) => Math.round(value)} />
                        <YAxis type="category" dataKey="name" width={100} />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend 
                            verticalAlign="top" 
                            align="right"
                            wrapperStyle={{ paddingBottom: "20px" }}
                        />
                        <Bar dataKey="Moins de 20 m2" fill={COLORS.primary}>
                            <LabelList position="center" formatter={(value) => (value > 5 ? `${value.toFixed(1)}%` : '')} fill="#FFFFFF" fontSize={11} />
                        </Bar>
                        <Bar dataKey="Plus de 20 m2" fill={COLORS.secondary}>
                            <LabelList position="center" formatter={(value) => (value > 5 ? `${value.toFixed(1)}%` : '')} fill="#FFFFFF" fontSize={11} />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        } else if (selectedIndicator === 'manager_function') {
            // Traitement spécial pour le type de formation des gérants (Santé vs Autres)
            console.log("Manager function data:", statsData);
            
            return (
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={statsData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis 
                            domain={[0, 100]} 
                            tickFormatter={(value) => Math.round(value)} 
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend 
                            verticalAlign="top" 
                            align="right"
                        />
                        <Bar dataKey="Santé" stackId="a" fill={COLORS.primary}>
                            <LabelList
                                dataKey="Santé"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                        <Bar dataKey="Autres" stackId="a" fill={COLORS.tertiary}>
                            <LabelList
                                dataKey="Autres"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        } else if (selectedIndicator === 'supply_source') {
            return (
                <ResponsiveContainer width="100%" height={500}>
                    <BarChart
                        data={statsData}
                        layout="vertical"
                        margin={{ top: 20, right: 30, left: 120, bottom: 5 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis type="number" domain={[0, 100]} tickFormatter={(value) => `${Math.round(value)}%`} />
                        <YAxis type="category" dataKey="name" width={120} />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend 
                            verticalAlign="top" 
                            align="right"
                            wrapperStyle={{ paddingBottom: "20px" }}
                        />
                        <Bar dataKey="Grossiste au marché" fill={COLORS.primary}>
                            <LabelList position="center" formatter={(value) => (value > 3 ? `${value.toFixed(1)}%` : '')} fill="#FFFFFF" fontSize={11} />
                        </Bar>
                        <Bar dataKey="Officine privée" fill={COLORS.secondary}>
                            <LabelList position="center" formatter={(value) => (value > 3 ? `${value.toFixed(1)}%` : '')} fill="#FFFFFF" fontSize={11} />
                        </Bar>
                        <Bar dataKey="Centrale privée" fill={COLORS.tertiary}>
                            <LabelList position="center" formatter={(value) => (value > 3 ? `${value.toFixed(1)}%` : '')} fill="#FFFFFF" fontSize={11} />
                        </Bar>
                        <Bar dataKey="Pharmacie populaire" fill={COLORS.quaternary}>
                            <LabelList position="center" formatter={(value) => (value > 3 ? `${value.toFixed(1)}%` : '')} fill="#FFFFFF" fontSize={11} />
                        </Bar>
                        <Bar dataKey="ONPPC" fill="#8B5CF6">
                            <LabelList position="center" formatter={(value) => (value > 3 ? `${value.toFixed(1)}%` : '')} fill="#FFFFFF" fontSize={11} />
                        </Bar>
                        <Bar dataKey="Autre dépôt" fill="#EC4899">
                            <LabelList position="center" formatter={(value) => (value > 3 ? `${value.toFixed(1)}%` : '')} fill="#FFFFFF" fontSize={11} />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        } else if (selectedIndicator === 'authorized_activities') {
            // Traitement spécial pour les activités autorisées
            const transformedData = statsData.map(item => ({
                name: item.name,
                'Activités autorisées': item.value === 1 ? 100 : 0,
                'Activités non autorisées': item.value === 0 ? 100 : 0
            }));
            
            return (
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={transformedData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis 
                            domain={[0, 100]} 
                            tickFormatter={(value) => Math.round(value)} 
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend 
                            verticalAlign="top" 
                            align="right"
                        />
                        <Bar dataKey="Activités autorisées" stackId="a" fill={COLORS.primary}>
                            <LabelList
                                dataKey="Activités autorisées"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                        <Bar dataKey="Activités non autorisées" stackId="a" fill={COLORS.tertiary}>
                            <LabelList
                                dataKey="Activités non autorisées"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        } else if (selectedIndicator === 'price_structure') {
            // Traitement spécial pour la structure des prix
            const transformedData = statsData.map(item => ({
                name: item.name,
                'Respecté': item.value === 1 ? 100 : 0,
                'Non respecté': item.value === 0 ? 100 : 0
            }));
            
            return (
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={transformedData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis 
                            domain={[0, 100]} 
                            tickFormatter={(value) => Math.round(value)} 
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend 
                            verticalAlign="top" 
                            align="right"
                        />
                        <Bar dataKey="Respecté" stackId="a" fill={COLORS.primary}>
                            <LabelList
                                dataKey="Respecté"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                        <Bar dataKey="Non respecté" stackId="a" fill={COLORS.tertiary}>
                            <LabelList
                                dataKey="Non respecté"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        } else if (selectedIndicator === 'storage_practice') {
            // Traitement spécial pour les bonnes pratiques de stockage et de distribution
            const transformedData = statsData.map(item => ({
                name: item.name,
                'Respecté': item.value === 1 ? 100 : 0,
                'Non respecté': item.value === 0 ? 100 : 0
            }));
            
            return (
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={transformedData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis 
                            domain={[0, 100]} 
                            tickFormatter={(value) => Math.round(value)} 
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend 
                            verticalAlign="top" 
                            align="right"
                        />
                        <Bar dataKey="Respecté" stackId="a" fill={COLORS.primary}>
                            <LabelList
                                dataKey="Respecté"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                        <Bar dataKey="Non respecté" stackId="a" fill={COLORS.tertiary}>
                            <LabelList
                                dataKey="Non respecté"
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        } else if (selectedIndicator === 'demographic_norm') {
            // Traitement spécial pour les normes démographiques
            const primaryDataKey = 'Norme respectée';
            const secondaryDataKey = 'Norme non-respectée';
            
            return (
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={statsData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis 
                            domain={[0, 100]} 
                            tickFormatter={(value) => Math.round(value)} 
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend 
                            verticalAlign="top" 
                            align="right"
                        />
                        <Bar dataKey={primaryDataKey} stackId="a" fill={COLORS.primary}>
                            <LabelList
                                dataKey={primaryDataKey}
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                        <Bar dataKey={secondaryDataKey} stackId="a" fill={COLORS.tertiary}>
                            <LabelList
                                dataKey={secondaryDataKey}
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        } else if (selectedIndicator === 'geographic_norm') {
            // Traitement spécial pour les normes géographiques
            const primaryDataKey = 'Localisation respecté';
            const secondaryDataKey = 'Localisation non-respecté';
            
            return (
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={statsData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis 
                            domain={[0, 100]} 
                            tickFormatter={(value) => Math.round(value)} 
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend 
                            verticalAlign="top" 
                            align="right"
                        />
                        <Bar dataKey={primaryDataKey} stackId="a" fill={COLORS.primary}>
                            <LabelList
                                dataKey={primaryDataKey}
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                        <Bar dataKey={secondaryDataKey} stackId="a" fill={COLORS.tertiary}>
                            <LabelList
                                dataKey={secondaryDataKey}
                                position="center"
                                formatter={(value) => (value > 10 ? `${value.toFixed(1)}%` : '')}
                                fill="#FFFFFF"
                                fontSize={11}
                                fontWeight="bold"
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            );
        }

        switch (selectedIndicator) {
            case 'retail_sale_norm':
            case 'manager_function':
                return (
                    <ResponsiveContainer width="100%" height={500}>
                        <BarChart
                            data={statsData}
                            layout="vertical"
                            margin={{ top: 20, right: 30, left: 100, bottom: 5 }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis type="number" domain={[0, 100]} tickFormatter={(value) => Math.round(value)} />
                            <YAxis type="category" dataKey="name" width={100} />
                            <Tooltip content={<CustomTooltip />} />
                            <Legend 
                                verticalAlign="top" 
                                align="right"
                                wrapperStyle={{ paddingBottom: "20px" }}
                            />
                            {selectedIndicator === 'manager_function' ? (
                                <>
                                    <Bar dataKey="Aucun" fill="#E5E7EB">
                                        <LabelList position="center" formatter={(value) => (value > 5 ? `${value.toFixed(1)}%` : '')} fill="#000000" fontSize={11} />
                                    </Bar>
                                    <Bar dataKey="Primaire" fill={COLORS.primary}>
                                        <LabelList position="center" formatter={(value) => (value > 5 ? `${value.toFixed(1)}%` : '')} fill="#FFFFFF" fontSize={11} />
                                    </Bar>
                                    <Bar dataKey="Secondaire" fill={COLORS.secondary}>
                                        <LabelList position="center" formatter={(value) => (value > 5 ? `${value.toFixed(1)}%` : '')} fill="#FFFFFF" fontSize={11} />
                                    </Bar>
                                    <Bar dataKey="Supérieur" fill={COLORS.tertiary}>
                                        <LabelList position="center" formatter={(value) => (value > 5 ? `${value.toFixed(1)}%` : '')} fill="#FFFFFF" fontSize={11} />
                                    </Bar>
                                </>
                            ) : (
                                <>
                                    <Bar dataKey="En gros/détails" fill={COLORS.primary}>
                                        <LabelList position="center" formatter={(value) => (value > 5 ? `${value.toFixed(1)}%` : '')} fill="#FFFFFF" fontSize={11} />
                                    </Bar>
                                    <Bar dataKey="Détails" fill={COLORS.secondary}>
                                        <LabelList position="center" formatter={(value) => (value > 5 ? `${value.toFixed(1)}%` : '')} fill="#FFFFFF" fontSize={11} />
                                    </Bar>
                                </>
                            )}
                        </BarChart>
                    </ResponsiveContainer>
                );
            default:
                return null;
        }
    };

    return (
        <Layout>
            <div className="container mx-auto px-4 py-8">
                <h1 className="text-2xl font-bold mb-6">Statistiques par indicateur</h1>
                <div className="w-full max-w-md mb-8">
                    <label htmlFor="indicator" className="block text-sm font-medium text-gray-700 mb-2">
                        Sélectionnez un indicateur
                    </label>
                    <select
                        id="indicator"
                        value={selectedIndicator}
                        onChange={(e) => setSelectedIndicator(e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                    >
                        <option value="">Sélectionnez un indicateur</option>
                        {indicators.filter(ind => !ind.notImplemented).map((indicator) => (
                            <option key={indicator.id} value={indicator.id}>
                                {indicator.label}
                            </option>
                        ))}
                    </select>
                </div>

                {loading && (
                    <div className="text-center py-4">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500 mx-auto"></div>
                    </div>
                )}

                {error && (
                    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
                        <span className="block sm:inline">{error}</span>
                    </div>
                )}

                {!loading && !error && selectedIndicator && (
                    <div className="bg-white p-6 rounded-lg shadow-lg">
                        <h2 className="text-xl font-semibold mb-4">
                            {indicators.find(i => i.id === selectedIndicator)?.chartTitle}
                        </h2>
                        {indicators.find(i => i.id === selectedIndicator)?.articleText && (
                            <div className="mb-6 p-4 bg-gray-50 rounded-lg text-sm">
                                <p className="italic">
                                    {indicators.find(i => i.id === selectedIndicator)?.articleText}
                                </p>
                            </div>
                        )}
                        {renderChart()}
                    </div>
                )}
            </div>
        </Layout>
    );
};

export default StateByIndicateurPage;


